import 'consumerweb-shim';
import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import $ from 'jquery'
import { Route, Switch, Router } from 'react-router-dom'
import history from './configureHistory';
import CookiedUserPage from './../pages/landing/landing'
import GuestPage from './../pages/guest/guest'
import CrossBorder from './../pages/guest/crossBorder'
import GuestConfirmation from './../pages/guest/confirmation'
import GuestPending from './../pages/guest/pending'
import PaymentError from './../pages/error/paymentError'
import UnilateralError from '../pages/error/UnilateralError';
import templateData from './../utility/getTemplateData'
import { isOneTouchUser } from 'utility/authUtils';
import { parseUrlQuery } from '../utility/urlUtils';
import { setShouldRTL } from '../utility/paypalAphrodite'
import ThreeDSError from '../pages/error/threeDSError';

// set the direction for styles (whether to convert them to RTL)
const { locality: { directionality = 'ltr' } = {} } = templateData
setShouldRTL(directionality !== 'rtl')


const { currentUserState, isUnilateralAccount } = templateData

class LandingPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			userCookied: currentUserState === 'cookied',
			isOneTouch: isOneTouchUser()
		}
	}

	componentDidMount() {
		if (isUnilateralAccount) {
			history.push('/donate/error/noaccount')
			return;
		}
		// Only hiding spinner for cookied user
		if (this.state.userCookied) {
			// In case of onboarding, guest.js will hide the spinner
			if (!templateData.onboardingEnabled) {
				$('.spinneroverlay').hide();
			}
		}
	}

	getPageToRender() {
		// If `signup` param is present, render GuestPage
		const isSignupRoute = !!parseUrlQuery().signup;
		if (isSignupRoute) {
			return <GuestPage />
		}
		return <CookiedUserPage/>;
	}

	render() {
		return (
			<div>{this.getPageToRender()}</div>
		)
	}
}

ReactDOM.render((
	<Router history={history}>
		<Switch>
			<Route exact path="/donate" component={LandingPage} />
			<Route exact path="/donate/guest" component={GuestPage} />
			<Route exact path="/donate/guest/crossborder" component={CrossBorder} />
			<Route exact path="/donate/guest/confirmation" component={GuestConfirmation} />
			<Route exact path="/donate/guest/pending" component={GuestPending} />
			<Route exact path="/donate/error/payment" component={PaymentError} />
			<Route exact path="/donate/error/noaccount" component={UnilateralError} />
			<Route exact path="/donate/error/threeDS" component={ThreeDSError} />
		</Switch>
	</Router>
), document.getElementById('donateWrapper'))
